// Local translations
export const T = {
  en_GB: {
    removeRow: "Remove row",
    title: "Title (optional)",
    titlePlaceholder: "Enter title...",
    titleHelp: "Optional heading to display above the table",
    description: "Description (optional)",
    descriptionPlaceholder: "Enter description...",
    descriptionHelp: "Optional text to display between the title and table",
    tableRows: "Table Rows",
    tableRowsHelp: 'Create a 2-column table. Use "Add Row" to insert fields or empty rows.',
    labelPlaceholder: "Label",
    valuePlaceholder: "Value or {{Field Name}}",
    addRow: "Add Row",
    emptyRow: "Empty Row",
    clientFields: "Client Fields",
    customFields: "Custom Fields",
    quizFields: "Quiz Results",
    quizOverrideFields: "Quiz overrides",
    quizExternalFields: "Quiz external results",
    ownerFields: "Owner Fields",
    goalFields: "Goal Fields",
    portfolioFields: "Portfolio Fields",
    portfolioMandateStatus: "Portfolio Mandate Status",
    portfolioMandateDeviationNote: "Portfolio Mandate Deviation Note",
    portfolioMandateDecidedBy: "Portfolio Mandate Decided By",
    portfolioMandateDecidedAt: "Portfolio Mandate Decided At",
    portfolioModelDeviation: "Portfolio Model Deviation",
    portfolioModelRiskScore: "Portfolio Model Risk Score",
    portfolioGoalRiskScore: "Portfolio Goal Risk Score",
    flowFields: "Flow Fields",
    flow: "Flow",
    document: "Document",
    // Client field labels
    clientName: "Name",
    clientType: "Type",
    clientEmail: "Email",
    clientMobilePhone: "Mobile Phone",
    clientSSN: "SSN",
    clientOrgId: "Org ID",
    clientCountry: "Country",
    clientGroupMembers: "Group members",
    clientRepresentative: "Representative",
    clientOwner: "Owner",
    // Owner field labels
    ownerName: "Name",
    ownerEmail: "Email",
    ownerPhone: "Phone Number",
    ownerTitle: "Title",
    ownerSignature: "Signature",
    // Flow instance field labels
    flowName: "Name",
    cancelReason: "Cancel Reason",
    expectingChanges: "Expecting Financial Changes",
    expectingChangesNote: "Expecting Financial Changes Note",
    // Document field labels
    today: "Today",
    // Goal field labels
    goalName: "Goal Name",
    portfolioName: "Portfolio Name",
    goalType: "Goal Type",
    goalDescription: "Goal Description",
    riskScore: "Risk Score",
    mandateName: "Mandate Name",
    mandateStatus: "Mandate Status",
    mandateSource: "Mandate Source",
    mandateOrigin: "Mandate Origin",
    mandateMode: "Mandate Mode",
    existingMandateName: "Existing Mandate Name",
    mandateDeviationNote: "Mandate Deviation Note",
    mandateDecidedBy: "Mandate Decided By",
    mandateDecidedAt: "Mandate Decided At",
    // Scope indicator
    goalScope: "[Goal]",
    portfolioScope: "[Portfolio]",
    // Validation
    columnWidth: "Column width",
    headerRow: "First row is a header",
    headerRowHelp:
      "Drawn in the template's header colours and repeated at the top of the next page if the table splits.",
    headerColumn: "First column is a header",
    validationAtLeastOneRow: "Please add at least one row to the table",
    validationAtLeastOneCell: "Please add content to at least one cell",
  },
  nb_NO: {
    removeRow: "Fjern rad",
    title: "Tittel (valgfri)",
    titlePlaceholder: "Skriv inn tittel...",
    titleHelp: "Valgfri overskrift som vises over tabellen",
    description: "Beskrivelse (valgfri)",
    descriptionPlaceholder: "Skriv inn beskrivelse...",
    descriptionHelp: "Valgfri tekst som vises mellom tittelen og tabellen",
    tableRows: "Tabellrader",
    tableRowsHelp:
      'Opprett en tabell med 2 kolonner. Bruk "Legg til rad" for å sette inn felt eller tomme rader.',
    labelPlaceholder: "Etikett",
    valuePlaceholder: "Verdi eller {{Feltnavn}}",
    addRow: "Legg til rad",
    emptyRow: "Tom rad",
    clientFields: "Kundefelt",
    customFields: "Egendefinerte felt",
    quizFields: "Quizresultater",
    quizOverrideFields: "Quiz-overstyringer",
    quizExternalFields: "Eksterne quiz-resultater",
    ownerFields: "Eierfelt",
    goalFields: "Målfelt",
    portfolioFields: "Porteføljefelt",
    portfolioMandateStatus: "Porteføljens mandatstatus",
    portfolioMandateDeviationNote: "Porteføljens mandatavvik begrunnelse",
    portfolioMandateDecidedBy: "Porteføljens mandatavvik akseptert av",
    portfolioMandateDecidedAt: "Porteføljens mandatavvik akseptert dato",
    portfolioModelDeviation: "Modellportefølje fra annen risikoscore",
    portfolioModelRiskScore: "Modellporteføljens risikoscore",
    portfolioGoalRiskScore: "Målets risikoscore",
    flowFields: "Flytfelt",
    flow: "Flyt",
    document: "Dokument",
    // Client field labels
    clientName: "Navn",
    clientType: "Type",
    clientEmail: "E-post",
    clientMobilePhone: "Mobiltelefon",
    clientSSN: "Fødselsnummer",
    clientOrgId: "Org.nr.",
    clientCountry: "Land",
    clientGroupMembers: "Gruppemedlemmer",
    clientRepresentative: "Representant",
    clientOwner: "Eier",
    // Owner field labels
    ownerName: "Navn",
    ownerEmail: "E-post",
    ownerPhone: "Telefonnummer",
    ownerTitle: "Tittel",
    ownerSignature: "Signatur",
    // Flow instance field labels
    flowName: "Navn",
    cancelReason: "Kanselleringsårsak",
    expectingChanges: "Forventede økonomiske endringer",
    expectingChangesNote: "Notat om forventede endringer",
    // Document field labels
    today: "I dag",
    // Goal field labels
    goalName: "Målnavn",
    portfolioName: "Porteføljenavn",
    goalType: "Måltype",
    goalDescription: "Målbeskrivelse",
    riskScore: "Risikoscore",
    mandateName: "Mandatnavn",
    mandateStatus: "Mandatstatus",
    mandateSource: "Mandatkilde",
    mandateOrigin: "Mandatopprinnelse",
    mandateMode: "Mandatmodus",
    existingMandateName: "Eksisterende mandatnavn",
    mandateDeviationNote: "Mandatavvik begrunnelse",
    mandateDecidedBy: "Mandatavvik akseptert av",
    mandateDecidedAt: "Mandatavvik akseptert dato",
    // Scope indicator
    goalScope: "[Mål]",
    portfolioScope: "[Portefølje]",
    // Validation
    columnWidth: "Kolonnebredde",
    headerRow: "Første rad er en overskrift",
    headerRowHelp:
      "Vises i malens overskriftsfarger og gjentas øverst på neste side hvis tabellen deles.",
    headerColumn: "Første kolonne er en overskrift",
    validationAtLeastOneRow: "Vennligst legg til minst én rad i tabellen",
    validationAtLeastOneCell: "Vennligst legg til innhold i minst én celle",
  },
} as const;
